const initialState = {
    isCreating: false,
    invoiceBeingRead: null,
    invoice: null,
    invoiceError: false,
    invoiceBeingUpdated: null
}

export default initialState;
